import React, { useEffect, useRef, useState } from "react";
import {
    Alert,
    Container,
    Dropdown,
    Form,
    InputGroup,
    Nav,
    Navbar,
    Overlay,
    Tooltip,
} from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import bilogo from "../../assets/images/QDlogo.svg";
import cart from "../../assets/images/cart.svg";
import notification from "../../assets/images/notification.svg";
import project from "../../assets/images/projects.svg";
import schedular from "../../assets/images/schedular.svg";
import workflowtimeline from "../../assets/images/schedular.svg";
import searchicon from "../../assets/images/searchicon.svg";
import service from "../../assets/images/service.svg";
// import profilepic from "../../assets/images/profilepic.png";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { googleLogout } from "@react-oauth/google";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AddToCartModal from "../../Modals/AddToCart";
import LogoutModal from "../../Modals/LogoutModal";
import WorkFlowPassModal from "../../Modals/WorkFlowPassModal";
import Support from "../../assets/images/Support.svg";
import accountprofile from "../../assets/images/accountprofile.svg";
import authentication from "../../assets/images/authentication.svg";
import automation from "../../assets/images/automation.svg";
import billingsplans from "../../assets/images/billingsplans.svg";
import WalletSVG from "../../assets/images/WalletSVG.svg";
import contacts from "../../assets/images/contacts.svg";
import hideeye from "../../assets/images/hideeye.svg";
import profilepic1 from "../../assets/images/dummy-profile-pic.jpg";
import legal from "../../assets/images/legal.svg";
import logout from "../../assets/images/logout.svg";
import marketplace from "../../assets/images/marketplace.svg";
import mymachine from "../../assets/images/mymachine-new.svg";
import notificationprofile from "../../assets/images/notificationprofile.svg";
import BillingCost from "../../assets/images/BillingAndCost.svg";
import policyprofile from "../../assets/images/policyprofile.svg";
import privacypolicy from "../../assets/images/privacypolicy.svg";
import profileicon from "../../assets/images/profileicon.svg";
import purchases from "../../assets/images/purchases.svg";
import { commonservices, CountCharacter } from "../../services/CommonServices";
import { CartGetList } from "../../services/ReduxTookit/Slice/CartRedux";
import {
    BecomeClient,
    BecomeDeveloper,
} from "../../services/ReduxTookit/Slice/SubscribersRedux";
import {
    organizations,
    SignalRKey,
    userInfo,
    userToken,
} from "../../services/ReduxTookit/UserInfoSlice";
import NotificationPopup from "./NotificationPopup";
import ServicesMenu from "./ServicesMenu";
import { RoleGetList } from "../../services/ReduxTookit/Slice/RoleRedux";
import { toast } from "react-toastify";
import copyicon from "../../assets/images/copyIcon.svg";
import dummyprofilepic from "../../assets/images/dummy-profile-pic.jpg";
import { GetByPrimarykey } from "../../services/ReduxTookit/Slice/UserRedux";
import {
    NotificationGetList,
    NotificationGetListHeader,
} from "../../services/ReduxTookit/Slice/NotificationRedux";
import aws from "../../assets/images/aws.svg";

function Header() {
    const CartList = useSelector(
        (state) => state?.cartredux?.CartGetListData?.data?.data?.data
    );
    const OrganizationList = useSelector(
        (state) => state?.userinfo?.Organizations
    );
    let OrgList =
        Array.isArray(OrganizationList) && OrganizationList.length > 0
            ? OrganizationList
            : [];
    let IsWorkflowUser = window?.location?.href?.includes(
        `${process.env.REACT_APP_WORKFLOW}`
    );

    let param = useParams();
    let Userdata = useSelector(
        (state) => state?.userredux?.GetByPrimarykeyData?.data?.data?.data
    );
    let UserDetailData = useSelector(
        (state) => state?.userredux?.GetByPrimarykeyData?.data?.data?.data
    );

    const [dropdownOpen, setDropdownOpen] = useState(false);
    let dispatch = useDispatch();
    let DevRoute = window.location.href.includes(`${process.env.REACT_APP_DEV}`);
    const [LogoutModalShow, setLogoutModalShow] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [ProfileModalShow, setProfileModalShow] = useState(false);
    const [workflowPassModalShow, setWorkflowPassModalShow] = useState(false);
    const [addToCartShow, setAddToCartShow] = useState(false);
    // const [moreLoading, setMoreLoading] = useState(false);
    // const [page, setPage] = useState(1);
    // const [totalRecord, setTotalRecord] = useState(1);
    // const [notificationList, setNotificationList] = useState([]);
    const notificationList = useSelector(
        (state) =>
            state?.notification?.NotificationGetListHeaderData?.data?.data?.data
    );

    const [connection, setConnection] = useState(null);

    const notificationListRef = useRef([]);

    const GetCartDetails = () => {
        dispatch(CartGetList({}));
    };

    const handleOverlay = (e) => {
        let element = document.getElementById(e?.currentTarget?.id);
        if (element) {
            if (element.classList.contains("overlay-isopen")) {
                element.classList.remove("overlay-isopen");
            } else {
                element.classList.add("overlay-isopen");
            }
        }
    };
    const handleshowMenu = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
            handleOverlay(e);
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowMenu(!showMenu);
    };
    const [showSearch, setShowSearch] = useState(false);

    const handleshowSearch = () => {
        setShowSearch(!showSearch);
    };
    const [showNotification, setShowNotification] = useState(false);
    const tokenValue = localStorage.getItem("Token");

    const getNotificationList = async () => {
        // alert("hhhhhhh");
        let body = {
            type: "",
            entrydate: "",
            notificationto: "",
            readby: `${Userdata?.userid}`,
            pagenumber: 1,
            pagesize: 10,
            associationid: "",
            associationtype: "",
        };
        dispatch(NotificationGetListHeader(body));
    };
    const handleshowNotification = () => {
        if (
            document
                .getElementById("body")
                .classList.contains("popup-is-open", "notification-popup-open")
        ) {
            document
                .getElementById("body")
                .classList.remove("popup-is-open", "notification-popup-open");
        } else {
            document
                .getElementById("body")
                .classList.add("popup-is-open", "notification-popup-open");
        }
        setShowNotification(!showNotification);
    };
    const location = useLocation();
    const navigate = useNavigate();

    const isActive = (path) => {
        return location.pathname === path ? "active" : "";
        // return DevRoute ? "active" : "";
    };
    const handleCopy = (content) => {
        navigator.clipboard
            .writeText(content)
            .then(() => {
                toast.success("Copied successfully");
            })
            .catch((err) => { });
    };
    const target1 = useRef(null);
    const target = useRef(null);
    const [show, setShow] = useState(false);

    function fnLogout() {
        if (connection) {
            connection
                .stop()
                .then(() => { })
                .catch((err) => { });
        }
        dispatch(userToken(null));
        dispatch(userInfo(null));
        dispatch(organizations(null));
        googleLogout();
        commonservices.clearLocalStorage();
    }

    const checkUserIsReviewer = () => {
        let isReviewer = false;
        if (Userdata?.associationtype === "Reviewers") {
            isReviewer = true;
        }
        return isReviewer;
    };

    const checkBecomeDeveloper = async () => {
        //  `http://localhost:3000/dashboard`

        // let resData = await axios({
        //   method: "PUT",
        //   url: API_URL.BASEURL + API_URL?.SUBSCRIBER?.BECOME_DEVELOPER,
        //   headers: commonservices?.getHeadersFromData(),
        // });
        // let response = apiResponse(false, resData?.data);
        dispatch(BecomeDeveloper({}))?.then((response) => {
            if (response?.payload?.isValidate) {
                if (response?.payload?.data?.data?.isredirect) {
                    window.location.href = `${process.env.REACT_APP_DEV}/dashboard`;
                }
            }
            if (!response?.payload?.isValidate) {
            }
        });
    };

    const checkBecomeClient = async () => {
        // let resData = await axios({
        //   method: "PUT",
        //   url: API_URL.BASEURL + API_URL?.SUBSCRIBER?.BECOME_CLIENT,
        //   headers: commonservices?.getHeadersFromData(),
        // });
        // let response = apiResponse(false, resData?.data);
        dispatch(BecomeClient({}))?.then((response) => {
            if (response?.payload?.isValidate) {
                if (response?.payload?.data?.data?.isredirect) {
                    window.location.href = `${process.env.REACT_APP_WORKFLOW}/dashboard`;
                }
                // navigate("/dashboard");
                // window.location.href =`http://localhost:3001/dashboard`
            }
            if (!response?.payload?.isValidate) {
            }
        });
    };

    const SignalR_UserLogConnect = (id) => {
        if (id && id !== "0" && id !== 0) {
            const connect = new HubConnectionBuilder()
                .withUrl(process.env.REACT_APP_SIGNAL_R, { withCredentials: false })
                .withAutomaticReconnect()
                .build();
            connect
                .start()
                .then(() => {
                    setConnection(connect);
                    dispatch(SignalRKey(JSON.stringify(connect)));
                    connect.send("userlogconnect", id);
                    connect.on("getuserlogupdate", (data) => {
                        commonservices.getUserLogDataInFormat(data, Userdata);
                    });
                })
                .catch((error) => { });
        }
    };
    let [trigger, setTrigger] = useState(false);

    const hasTriggered = useRef(false);
    useEffect(() => {
        if (!hasTriggered.current && Userdata && !trigger) {
            if (connection) {
                connection
                    .stop()
                    .then(() => {
                        SignalR_UserLogConnect(Userdata.userid);
                    })
                    .catch((err) => { });
            } else {
                SignalR_UserLogConnect(Userdata.userid);
            }
            setTrigger(true);
            GetCartDetails();
            dispatch(RoleGetList());

            hasTriggered.current = true; // Mark the effect as triggered
        }

        return () => {
            if (connection) {
                connection
                    .stop()
                    .then(() => { })
                    .catch((err) => { });
            }
        };
    }, [Userdata, trigger, tokenValue]);
    useEffect(() => {
        dispatch(GetByPrimarykey({}));
        getNotificationList();
        return () => {
            if (connection) {
                connection
                    .stop()
                    .then(() => { })
                    .catch((err) => { });
            }
        };
    }, [tokenValue]);

    //#region Close ToolTip / Overlays Outside Click ----------------------

    const overlayNoti_Ref = useRef(null);
    const overlayMenues_Ref = useRef(null);

    const handleOutsideClick = (event) => {
        if (
            overlayNoti_Ref.current &&
            !overlayNoti_Ref.current.contains(event.target) &&
            !target.current.contains(event.target)
        ) {
            handleshowNotification(event); // Close the overlay
        }
        if (
            overlayMenues_Ref.current &&
            !overlayMenues_Ref.current.contains(event.target) &&
            !target1.current.contains(event.target)
        ) {
            handleshowMenu(event); // Close the overlay
        }
    };

    useEffect(() => {
        if (showNotification) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else if (showMenu) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else {
            document.removeEventListener("mousedown", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [showNotification, showMenu]);

    //#endregion ----------------------

    return (
        <div className="header-main">
            <Navbar expand="md">
                <Container>
                    <Link to="/dashboard">
                        <Navbar.Brand>
                            <img src={bilogo} alt="logo" />
                        </Navbar.Brand>
                    </Link>

                    <div className="navbar-right navbar-right-mobile">
                        {showSearch ? (
                            <div className="header-search-input searchplaceholder">
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1">
                                        <img src={searchicon} alt="searchicon" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder="Search"
                                        aria-label="Search"
                                        aria-describedby="basic-addon1"
                                    />
                                </InputGroup>
                            </div>
                        ) : (
                            <img
                                src={searchicon}
                                alt="searchicon"
                                onClick={handleshowSearch}
                            />
                        )}
                        <img
                            src={cart}
                            alt="Cart"
                        // ref={target}
                        />
                        <img
                            className={
                                showNotification ? "overlay-isopen sm-icons" : "sm-icons"
                            }
                            src={notification}
                            alt="profilepic"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowNotification(!showNotification);
                                handleshowNotification();
                            }}
                            ref={target}
                        />
                        <img
                            src={service}
                            alt="home"
                            id="service-menu"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowMenu(!showMenu);
                                handleshowMenu();
                            }}
                            className={showMenu ? "overlay-isopen sm-icons" : "sm-icons"}
                            ref={target1}
                        />
                        <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic">
                                <img
                                    src={
                                        UserDetailData?.profilepicurl ||
                                        Userdata?.profilepicurl ||
                                        profilepic1
                                    }
                                    alt="profile"
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = profilepic1;
                                    }}
                                />
                                <span title={Userdata?.displayname}>
                                    {commonservices?.truncateText(
                                        Userdata?.displayname,
                                        CountCharacter.HeaderDisplayName
                                    )}
                                </span>
                                <p>{Userdata?.associationtype}</p>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <Navbar.Offcanvas
                        id="navbarScroll"
                        aria-labelledby="offcanvasNavbarLabel-expand-xl"
                    >
                        <Offcanvas.Header closeButton></Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="me-auto my-2 my-lg-0">
                                {!checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => navigate("/dashboard")}
                                        className={isActive("/dashboard")}
                                    >
                                        <div className="nav-link-inner">
                                            <svg
                                                className="inactive-nav-icon"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g id="fi_1946488" clip-path="url(#clip0_0_6845)">
                                                    <path
                                                        id="Vector"
                                                        d="M20.5792 9.65068C20.5786 9.65022 20.5781 9.6496 20.5776 9.64914L12.3504 1.42304C11.9997 1.07224 11.5335 0.87915 11.0375 0.87915C10.5416 0.87915 10.0754 1.07224 9.72453 1.42304L1.50161 9.64499C1.49884 9.64775 1.49592 9.65068 1.4933 9.65345C0.773165 10.3777 0.774396 11.5527 1.49684 12.2751C1.8269 12.6052 2.26268 12.7963 2.72876 12.8165C2.74784 12.8183 2.76692 12.8193 2.78616 12.8193H3.11391V18.873C3.11391 20.0711 4.08886 21.0458 5.28709 21.0458H8.50585C8.83221 21.0458 9.09673 20.7812 9.09673 20.455V15.7087C9.09673 15.1621 9.54158 14.7174 10.0883 14.7174H11.9868C12.5335 14.7174 12.9782 15.1621 12.9782 15.7087V20.455C12.9782 20.7812 13.2427 21.0458 13.5691 21.0458H16.7879C17.9862 21.0458 18.961 20.0711 18.961 18.873V12.8193H19.2651C19.7609 12.8193 20.2271 12.6262 20.5781 12.2752C21.3013 11.5518 21.3016 10.3746 20.5792 9.65068ZM19.7424 11.4398C19.6149 11.5673 19.4453 11.6376 19.2651 11.6376H18.3702C18.0438 11.6376 17.7793 11.9021 17.7793 12.2284V18.873C17.7793 19.4195 17.3346 19.8642 16.7879 19.8642H14.16V15.7087C14.16 14.5106 13.1852 13.5358 11.9868 13.5358H10.0883C8.88992 13.5358 7.91497 14.5106 7.91497 15.7087V19.8642H5.28709C4.74052 19.8642 4.29567 19.4195 4.29567 18.873V12.2284C4.29567 11.9021 4.03116 11.6376 3.70479 11.6376H2.82524C2.81601 11.637 2.80693 11.6365 2.79754 11.6364C2.62151 11.6333 2.4564 11.5635 2.33269 11.4396C2.06956 11.1765 2.06956 10.7483 2.33269 10.4851C2.33284 10.4851 2.33284 10.4849 2.333 10.4847L2.33346 10.4843L10.5604 2.2585C10.6878 2.13095 10.8572 2.06079 11.0375 2.06079C11.2177 2.06079 11.3872 2.13095 11.5147 2.2585L19.7398 10.4826C19.741 10.4838 19.7424 10.4851 19.7436 10.4863C20.0054 10.7498 20.0049 11.1771 19.7424 11.4398Z"
                                                        fill="#5E5E5E"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_0_6845">
                                                        <rect width="22" height="22" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                            <svg
                                                className="active-nav-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                            >
                                                <g clip-path="url(#clip0_2769_20345)">
                                                    <path
                                                        d="M1.5 10.5L11 1.5L18 8L20.5 11.5L18 13V20H13.5V14.5H8.5V20H4L3.5 12.5L2.5 12L1.5 10.5Z"
                                                        fill="#111111"
                                                    />
                                                    <path
                                                        d="M20.5802 9.65043C20.5795 9.64997 20.5791 9.64936 20.5786 9.6489L12.3514 1.4228C12.0007 1.072 11.5345 0.878906 11.0385 0.878906C10.5426 0.878906 10.0763 1.072 9.72551 1.4228L1.50259 9.64474C1.49982 9.64751 1.49689 9.65043 1.49428 9.6532C0.774142 10.3774 0.775373 11.5524 1.49782 12.2748C1.82788 12.605 2.26365 12.7961 2.72974 12.8162C2.74882 12.8181 2.7679 12.819 2.78713 12.819H3.11489V18.8728C3.11489 20.0709 4.08984 21.0456 5.28806 21.0456H8.50682C8.83319 21.0456 9.0977 20.7809 9.0977 20.4548V15.7085C9.0977 15.1618 9.54255 14.7172 10.0893 14.7172H11.9878C12.5345 14.7172 12.9792 15.1618 12.9792 15.7085V20.4548C12.9792 20.7809 13.2437 21.0456 13.5701 21.0456H16.7888C17.9872 21.0456 18.962 20.0709 18.962 18.8728V12.819H19.2661C19.7619 12.819 20.2281 12.6259 20.5791 12.275C21.3023 11.5515 21.3026 10.3743 20.5802 9.65043ZM19.7434 11.4395C19.6158 11.5671 19.4463 11.6374 19.2661 11.6374H18.3711C18.0448 11.6374 17.7803 11.9019 17.7803 12.2282V18.8728C17.7803 19.4193 17.3356 19.8639 16.7888 19.8639H14.161V15.7085C14.161 14.5104 13.1862 13.5355 11.9878 13.5355H10.0893C8.89089 13.5355 7.91594 14.5104 7.91594 15.7085V19.8639H5.28806C4.7415 19.8639 4.29665 19.4193 4.29665 18.8728V12.2282C4.29665 11.9019 4.03214 11.6374 3.70577 11.6374H2.82622C2.81699 11.6368 2.80791 11.6363 2.79852 11.6361C2.62249 11.6331 2.45738 11.5632 2.33366 11.4394C2.07054 11.1763 2.07054 10.7481 2.33366 10.4848C2.33382 10.4848 2.33382 10.4847 2.33397 10.4845L2.33443 10.484L10.5614 2.25826C10.6888 2.13071 10.8582 2.06055 11.0385 2.06055C11.2187 2.06055 11.3881 2.13071 11.5157 2.25826L19.7408 10.4824C19.742 10.4836 19.7434 10.4848 19.7446 10.486C20.0064 10.7496 20.0059 11.1769 19.7434 11.4395Z"
                                                        fill="#111111"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2769_20345">
                                                        <rect width="22" height="22" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span>Home</span>
                                        </div>
                                    </Nav.Link>
                                )}

                                {!DevRoute && !checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => navigate("/workflows")}
                                        className={isActive("/workflows")}
                                    >
                                        <div className="nav-link-inner">
                                            <svg
                                                className="inactive-nav-icon"
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.5 15C1.5 14.4696 1.71071 13.9609 2.08579 13.5858C2.46086 13.2107 2.96957 13 3.5 13H5.5C6.03043 13 6.53914 13.2107 6.91421 13.5858C7.28929 13.9609 7.5 14.4696 7.5 15V17C7.5 17.5304 7.28929 18.0391 6.91421 18.4142C6.53914 18.7893 6.03043 19 5.5 19H3.5C2.96957 19 2.46086 18.7893 2.08579 18.4142C1.71071 18.0391 1.5 17.5304 1.5 17V15Z"
                                                    stroke="#5E5E5E"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M13.5 15C13.5 14.4696 13.7107 13.9609 14.0858 13.5858C14.4609 13.2107 14.9696 13 15.5 13H17.5C18.0304 13 18.5391 13.2107 18.9142 13.5858C19.2893 13.9609 19.5 14.4696 19.5 15V17C19.5 17.5304 19.2893 18.0391 18.9142 18.4142C18.5391 18.7893 18.0304 19 17.5 19H15.5C14.9696 19 14.4609 18.7893 14.0858 18.4142C13.7107 18.0391 13.5 17.5304 13.5 17V15Z"
                                                    stroke="#5E5E5E"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M7.5 3C7.5 2.46957 7.71071 1.96086 8.08579 1.58579C8.46086 1.21071 8.96957 1 9.5 1H11.5C12.0304 1 12.5391 1.21071 12.9142 1.58579C13.2893 1.96086 13.5 2.46957 13.5 3V5C13.5 5.53043 13.2893 6.03914 12.9142 6.41421C12.5391 6.78929 12.0304 7 11.5 7H9.5C8.96957 7 8.46086 6.78929 8.08579 6.41421C7.71071 6.03914 7.5 5.53043 7.5 5V3Z"
                                                    stroke="#5E5E5E"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M4.5 13V12C4.5 11.4696 4.71071 10.9609 5.08579 10.5858C5.46086 10.2107 5.96957 10 6.5 10H14.5C15.0304 10 15.5391 10.2107 15.9142 10.5858C16.2893 10.9609 16.5 11.4696 16.5 12V13"
                                                    stroke="#5E5E5E"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M10.5 7V10"
                                                    stroke="#5E5E5E"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>

                                            <svg
                                                className="active-nav-icon"
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M0.5 14.667C0.5 13.9597 0.780987 13.2813 1.28115 12.7811C1.78131 12.281 2.45967 12 3.167 12H5.833C6.54033 12 7.21869 12.281 7.71885 12.7811C8.21901 13.2813 8.5 13.9597 8.5 14.667V17.333C8.5 18.0403 8.21901 18.7187 7.71885 19.2189C7.21869 19.719 6.54033 20 5.833 20H3.167C2.81676 20 2.46996 19.931 2.14638 19.797C1.82281 19.663 1.5288 19.4665 1.28115 19.2189C1.03349 18.9712 0.837042 18.6772 0.703013 18.3536C0.568984 18.03 0.5 17.6832 0.5 17.333V14.667Z"
                                                    fill="#111111"
                                                />
                                                <path
                                                    d="M12.5 14.667C12.5 14.3168 12.569 13.97 12.703 13.6464C12.837 13.3228 13.0335 13.0288 13.2811 12.7811C13.5288 12.5335 13.8228 12.337 14.1464 12.203C14.47 12.069 14.8168 12 15.167 12H17.833C18.5403 12 19.2187 12.281 19.7189 12.7811C20.219 13.2813 20.5 13.9597 20.5 14.667V17.333C20.5 17.6832 20.431 18.03 20.297 18.3536C20.163 18.6772 19.9665 18.9712 19.7189 19.2189C19.4712 19.4665 19.1772 19.663 18.8536 19.797C18.53 19.931 18.1832 20 17.833 20H15.167C14.8168 20 14.47 19.931 14.1464 19.797C13.8228 19.663 13.5288 19.4665 13.2811 19.2189C13.0335 18.9712 12.837 18.6772 12.703 18.3536C12.569 18.03 12.5 17.6832 12.5 17.333V14.667Z"
                                                    fill="#111111"
                                                />
                                                <path
                                                    d="M6.5 2.667C6.5 1.95967 6.78099 1.28131 7.28115 0.781146C7.78131 0.280987 8.45967 0 9.167 0H11.833C12.5403 0 13.2187 0.280987 13.7189 0.781146C14.219 1.28131 14.5 1.95967 14.5 2.667V5.333C14.5 6.04033 14.219 6.71869 13.7189 7.21885C13.2187 7.71901 12.5403 8 11.833 8H9.167C8.45967 8 7.78131 7.71901 7.28115 7.21885C6.78099 6.71869 6.5 6.04033 6.5 5.333V2.667Z"
                                                    fill="#111111"
                                                />
                                                <path
                                                    d="M10.5 6C10.2348 6 9.98043 6.10536 9.79289 6.29289C9.60536 6.48043 9.5 6.73478 9.5 7V9H6.5C4.855 9 3.5 10.355 3.5 12V13C3.5 13.2652 3.60536 13.5196 3.79289 13.7071C3.98043 13.8946 4.23478 14 4.5 14C4.76522 14 5.01957 13.8946 5.20711 13.7071C5.39464 13.5196 5.5 13.2652 5.5 13V12C5.5 11.436 5.936 11 6.5 11H14.5C15.064 11 15.5 11.436 15.5 12V13C15.5 13.2652 15.6054 13.5196 15.7929 13.7071C15.9804 13.8946 16.2348 14 16.5 14C16.7652 14 17.0196 13.8946 17.2071 13.7071C17.3946 13.5196 17.5 13.2652 17.5 13V12C17.5 10.355 16.145 9 14.5 9H11.5V7C11.5 6.73478 11.3946 6.48043 11.2071 6.29289C11.0196 6.10536 10.7652 6 10.5 6Z"
                                                    fill="#111111"
                                                />
                                            </svg>

                                            <span>Workflow</span>
                                        </div>
                                    </Nav.Link>
                                )}


                                {!DevRoute && !checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => navigate("/sandboxs")}
                                        className={isActive("/sandboxs")}
                                    >
                                        <div className="nav-link-inner">
                                            <svg
                                                className="inactive-nav-icon"
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.5 15C1.5 14.4696 1.71071 13.9609 2.08579 13.5858C2.46086 13.2107 2.96957 13 3.5 13H5.5C6.03043 13 6.53914 13.2107 6.91421 13.5858C7.28929 13.9609 7.5 14.4696 7.5 15V17C7.5 17.5304 7.28929 18.0391 6.91421 18.4142C6.53914 18.7893 6.03043 19 5.5 19H3.5C2.96957 19 2.46086 18.7893 2.08579 18.4142C1.71071 18.0391 1.5 17.5304 1.5 17V15Z"
                                                    stroke="#5E5E5E"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M13.5 15C13.5 14.4696 13.7107 13.9609 14.0858 13.5858C14.4609 13.2107 14.9696 13 15.5 13H17.5C18.0304 13 18.5391 13.2107 18.9142 13.5858C19.2893 13.9609 19.5 14.4696 19.5 15V17C19.5 17.5304 19.2893 18.0391 18.9142 18.4142C18.5391 18.7893 18.0304 19 17.5 19H15.5C14.9696 19 14.4609 18.7893 14.0858 18.4142C13.7107 18.0391 13.5 17.5304 13.5 17V15Z"
                                                    stroke="#5E5E5E"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M7.5 3C7.5 2.46957 7.71071 1.96086 8.08579 1.58579C8.46086 1.21071 8.96957 1 9.5 1H11.5C12.0304 1 12.5391 1.21071 12.9142 1.58579C13.2893 1.96086 13.5 2.46957 13.5 3V5C13.5 5.53043 13.2893 6.03914 12.9142 6.41421C12.5391 6.78929 12.0304 7 11.5 7H9.5C8.96957 7 8.46086 6.78929 8.08579 6.41421C7.71071 6.03914 7.5 5.53043 7.5 5V3Z"
                                                    stroke="#5E5E5E"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M4.5 13V12C4.5 11.4696 4.71071 10.9609 5.08579 10.5858C5.46086 10.2107 5.96957 10 6.5 10H14.5C15.0304 10 15.5391 10.2107 15.9142 10.5858C16.2893 10.9609 16.5 11.4696 16.5 12V13"
                                                    stroke="#5E5E5E"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M10.5 7V10"
                                                    stroke="#5E5E5E"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>

                                            <svg
                                                className="active-nav-icon"
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M0.5 14.667C0.5 13.9597 0.780987 13.2813 1.28115 12.7811C1.78131 12.281 2.45967 12 3.167 12H5.833C6.54033 12 7.21869 12.281 7.71885 12.7811C8.21901 13.2813 8.5 13.9597 8.5 14.667V17.333C8.5 18.0403 8.21901 18.7187 7.71885 19.2189C7.21869 19.719 6.54033 20 5.833 20H3.167C2.81676 20 2.46996 19.931 2.14638 19.797C1.82281 19.663 1.5288 19.4665 1.28115 19.2189C1.03349 18.9712 0.837042 18.6772 0.703013 18.3536C0.568984 18.03 0.5 17.6832 0.5 17.333V14.667Z"
                                                    fill="#111111"
                                                />
                                                <path
                                                    d="M12.5 14.667C12.5 14.3168 12.569 13.97 12.703 13.6464C12.837 13.3228 13.0335 13.0288 13.2811 12.7811C13.5288 12.5335 13.8228 12.337 14.1464 12.203C14.47 12.069 14.8168 12 15.167 12H17.833C18.5403 12 19.2187 12.281 19.7189 12.7811C20.219 13.2813 20.5 13.9597 20.5 14.667V17.333C20.5 17.6832 20.431 18.03 20.297 18.3536C20.163 18.6772 19.9665 18.9712 19.7189 19.2189C19.4712 19.4665 19.1772 19.663 18.8536 19.797C18.53 19.931 18.1832 20 17.833 20H15.167C14.8168 20 14.47 19.931 14.1464 19.797C13.8228 19.663 13.5288 19.4665 13.2811 19.2189C13.0335 18.9712 12.837 18.6772 12.703 18.3536C12.569 18.03 12.5 17.6832 12.5 17.333V14.667Z"
                                                    fill="#111111"
                                                />
                                                <path
                                                    d="M6.5 2.667C6.5 1.95967 6.78099 1.28131 7.28115 0.781146C7.78131 0.280987 8.45967 0 9.167 0H11.833C12.5403 0 13.2187 0.280987 13.7189 0.781146C14.219 1.28131 14.5 1.95967 14.5 2.667V5.333C14.5 6.04033 14.219 6.71869 13.7189 7.21885C13.2187 7.71901 12.5403 8 11.833 8H9.167C8.45967 8 7.78131 7.71901 7.28115 7.21885C6.78099 6.71869 6.5 6.04033 6.5 5.333V2.667Z"
                                                    fill="#111111"
                                                />
                                                <path
                                                    d="M10.5 6C10.2348 6 9.98043 6.10536 9.79289 6.29289C9.60536 6.48043 9.5 6.73478 9.5 7V9H6.5C4.855 9 3.5 10.355 3.5 12V13C3.5 13.2652 3.60536 13.5196 3.79289 13.7071C3.98043 13.8946 4.23478 14 4.5 14C4.76522 14 5.01957 13.8946 5.20711 13.7071C5.39464 13.5196 5.5 13.2652 5.5 13V12C5.5 11.436 5.936 11 6.5 11H14.5C15.064 11 15.5 11.436 15.5 12V13C15.5 13.2652 15.6054 13.5196 15.7929 13.7071C15.9804 13.8946 16.2348 14 16.5 14C16.7652 14 17.0196 13.8946 17.2071 13.7071C17.3946 13.5196 17.5 13.2652 17.5 13V12C17.5 10.355 16.145 9 14.5 9H11.5V7C11.5 6.73478 11.3946 6.48043 11.2071 6.29289C11.0196 6.10536 10.7652 6 10.5 6Z"
                                                    fill="#111111"
                                                />
                                            </svg>

                                            <span>Sandbox</span>
                                        </div>
                                    </Nav.Link>
                                )}
                                {!DevRoute && !checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => navigate("/eks-node-group")}
                                        className={isActive("/eks-node-group")}
                                    >
                                        <div className="nav-link-inner">
                                            <svg
                                                className="inactive-nav-icon"
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    x="3"
                                                    y="2"
                                                    width="15"
                                                    height="16"
                                                    rx="2"
                                                    stroke="#5E5E5E"
                                                    strokeWidth="1.5"
                                                />

                                                <path
                                                    d="M6 6H15"
                                                    stroke="#5E5E5E"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />

                                                <path
                                                    d="M6 10H15"
                                                    stroke="#5E5E5E"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />

                                                <path
                                                    d="M6 14H10"
                                                    stroke="#5E5E5E"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />

                                                <circle
                                                    cx="14"
                                                    cy="14"
                                                    r="1"
                                                    fill="#5E5E5E"
                                                />
                                            </svg>
                                            <svg
                                                className="active-nav-icon"
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    x="3"
                                                    y="2"
                                                    width="15"
                                                    height="16"
                                                    rx="2"
                                                    stroke="#111111"
                                                    strokeWidth="1.5"
                                                />

                                                <path
                                                    d="M6 6H15"
                                                    stroke="#111111"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />

                                                <path
                                                    d="M6 10H15"
                                                    stroke="#111111"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />

                                                <path
                                                    d="M6 14H10"
                                                    stroke="#111111"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />

                                                <circle
                                                    cx="14"
                                                    cy="14"
                                                    r="1"
                                                    fill="#111111"
                                                />
                                            </svg>
                                            <span>Compute</span>
                                        </div>
                                    </Nav.Link>
                                )}

                                {!DevRoute && !checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => navigate("/database")}
                                        className={isActive("/database")}
                                    >
                                        <div className="nav-link-inner">
                                            <svg
                                                className="inactive-nav-icon"
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <ellipse
                                                    cx="10.5"
                                                    cy="4"
                                                    rx="8"
                                                    ry="3"
                                                    stroke="#5E5E5E"
                                                    strokeWidth="1.5"
                                                />
                                                <path
                                                    d="M2.5 4V10C2.5 11.657 6.084 13 10.5 13C14.916 13 18.5 11.657 18.5 10V4"
                                                    stroke="#5E5E5E"
                                                    strokeWidth="1.5"
                                                />
                                                <path
                                                    d="M2.5 10V16C2.5 17.657 6.084 19 10.5 19C14.916 19 18.5 17.657 18.5 16V10"
                                                    stroke="#5E5E5E"
                                                    strokeWidth="1.5"
                                                />
                                            </svg>

                                            <svg
                                                className="active-nav-icon"
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <ellipse
                                                    cx="10.5"
                                                    cy="4"
                                                    rx="8"
                                                    ry="3"
                                                    fill="#111111"
                                                    stroke="#111111"
                                                    strokeWidth="1.5"
                                                />
                                                <path
                                                    d="M2.5 4V10C2.5 11.657 6.084 13 10.5 13C14.916 13 18.5 11.657 18.5 10V4"
                                                    stroke="#111111"
                                                    strokeWidth="1.5"
                                                />
                                                <path
                                                    d="M2.5 10V16C2.5 17.657 6.084 19 10.5 19C14.916 19 18.5 17.657 18.5 16V10"
                                                    stroke="#111111"
                                                    strokeWidth="1.5"
                                                />
                                            </svg>

                                            <span>Database</span>
                                        </div>
                                    </Nav.Link>
                                )}

                                {/* {!DevRoute && !checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => navigate("/scheduler")}
                                        className={
                                            isActive("/scheduler") ||
                                            isActive("/scheduler/schedular-detail")
                                        }
                                    >
                                        <div className="nav-link-inner">
                                            <img
                                                src={schedular}
                                                alt="home"
                                                className="inactive-nav-icon"
                                            />
                                            <svg
                                                className="active-nav-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="23"
                                                height="22"
                                                viewBox="0 0 23 22"
                                                fill="none"
                                            >
                                                <g clip-path="url(#clip0_5514_10475)">
                                                    <path
                                                        d="M13.4993 0.18988C13.3671 0.165555 13.2312 0.17059 13.1012 0.204631C12.9712 0.238671 12.8502 0.300884 12.7469 0.386861C12.6436 0.472839 12.5605 0.580478 12.5034 0.702155C12.4464 0.823831 12.4167 0.956568 12.4167 1.09096V3.73005C11.3068 3.5828 10.1779 3.69313 9.11754 4.05249C8.05718 4.41184 7.09381 5.01057 6.30213 5.80225C5.51045 6.59393 4.91172 7.5573 4.55236 8.61766C4.19301 9.67803 4.08268 10.8069 4.22993 11.9168H1.59084C1.45645 11.9169 1.32371 11.9465 1.20203 12.0035C1.08036 12.0606 0.972718 12.1437 0.886741 12.247C0.800763 12.3503 0.738551 12.4713 0.70451 12.6013C0.67047 12.7313 0.665434 12.8672 0.68976 12.9994C1.05277 14.9716 1.94801 16.8071 3.27867 18.3073C4.60934 19.8076 6.32481 20.9155 8.23959 21.5114C10.1544 22.1072 12.1956 22.1683 14.1426 21.688C16.0896 21.2077 17.8682 20.2043 19.2862 18.7863C20.7042 17.3683 21.7076 15.5897 22.1879 13.6427C22.6682 11.6957 22.6071 9.65449 22.0112 7.73971C21.4154 5.82493 20.3074 4.10946 18.8072 2.77879C17.3069 1.44813 15.4715 0.55289 13.4993 0.18988ZM11.5 12.8335C11.1795 12.8326 10.8648 12.7474 10.5876 12.5865C10.3104 12.4256 10.0804 12.1947 9.92059 11.9168H7.83334C7.59023 11.9168 7.35707 11.8202 7.18516 11.6483C7.01325 11.4764 6.91668 11.2432 6.91668 11.0001C6.91668 10.757 7.01325 10.5239 7.18516 10.3519C7.35707 10.18 7.59023 10.0835 7.83334 10.0835H9.92059C10.0804 9.80885 10.3087 9.58047 10.5833 9.42071V6.4168C10.5833 6.17368 10.6799 5.94052 10.8518 5.76862C11.0237 5.59671 11.2569 5.50013 11.5 5.50013C11.7431 5.50013 11.9763 5.59671 12.1482 5.76862C12.3201 5.94052 12.4167 6.17368 12.4167 6.4168V9.42071C12.7663 9.62158 13.0397 9.93242 13.1943 10.3048C13.3489 10.6773 13.3761 11.0904 13.2715 11.4798C13.1669 11.8692 12.9364 12.2131 12.616 12.458C12.2956 12.7028 11.9032 12.8348 11.5 12.8335ZM9.64101 0.0917969C9.82231 0.0917969 9.99954 0.145558 10.1503 0.246283C10.301 0.347008 10.4185 0.490171 10.4879 0.65767C10.5573 0.825169 10.5754 1.00948 10.5401 1.1873C10.5047 1.36511 10.4174 1.52845 10.2892 1.65664C10.161 1.78484 9.99766 1.87215 9.81984 1.90752C9.64203 1.94289 9.45772 1.92473 9.29022 1.85535C9.12272 1.78597 8.97955 1.66848 8.87883 1.51774C8.7781 1.36699 8.72434 1.18976 8.72434 1.00846C8.72434 0.765348 8.82092 0.532191 8.99283 0.360282C9.16474 0.188374 9.39789 0.0917969 9.64101 0.0917969ZM5.88268 1.70146C6.06398 1.70146 6.2412 1.75523 6.39195 1.85595C6.54269 1.95667 6.66019 2.09984 6.72957 2.26734C6.79895 2.43484 6.8171 2.61915 6.78173 2.79696C6.74636 2.97478 6.65906 3.13811 6.53086 3.26631C6.40266 3.39451 6.23933 3.48181 6.06151 3.51718C5.88369 3.55255 5.69938 3.5344 5.53188 3.46502C5.36438 3.39564 5.22122 3.27815 5.1205 3.1274C5.01977 2.97666 4.96601 2.79943 4.96601 2.61813C4.96552 2.37517 5.06151 2.14196 5.23287 1.96973C5.40424 1.79751 5.63697 1.70036 5.87993 1.69963L5.88268 1.70146ZM3.04743 4.43771C3.22873 4.43771 3.40595 4.49148 3.5567 4.5922C3.70744 4.69292 3.82494 4.83609 3.89432 5.00359C3.9637 5.17109 3.98185 5.3554 3.94648 5.53321C3.91111 5.71103 3.82381 5.87436 3.69561 6.00256C3.56741 6.13076 3.40408 6.21806 3.22626 6.25343C3.04844 6.2888 2.86413 6.27065 2.69663 6.20127C2.52913 6.13189 2.38597 6.0144 2.28525 5.86365C2.18452 5.71291 2.13076 5.53568 2.13076 5.35438C2.13076 5.11127 2.22734 4.87811 2.39925 4.7062C2.57115 4.53429 2.80431 4.43771 3.04743 4.43771ZM1.58076 8.25746C1.76206 8.25746 1.93929 8.31122 2.09003 8.41195C2.24078 8.51267 2.35827 8.65584 2.42765 8.82334C2.49703 8.99084 2.51518 9.17515 2.47981 9.35296C2.44444 9.53078 2.35714 9.69411 2.22894 9.82231C2.10074 9.95051 1.93741 10.0378 1.75959 10.0732C1.58178 10.1086 1.39747 10.0904 1.22997 10.021C1.06247 9.95164 0.919304 9.83415 0.818579 9.6834C0.717855 9.53266 0.664093 9.35543 0.664093 9.17413C0.664093 8.93133 0.760418 8.69845 0.93193 8.5266C1.10344 8.35474 1.33613 8.25795 1.57893 8.25746H1.58076Z"
                                                        fill="black"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_5514_10475">
                                                        <rect
                                                            width="22"
                                                            height="22"
                                                            fill="white"
                                                            transform="translate(0.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span>Scheduler</span>
                                        </div>
                                    </Nav.Link>
                                )} */}
                                {!DevRoute && !checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => navigate("/workflowtimeline")}
                                        className={
                                            isActive("/workflowtimeline")
                                        }
                                    >
                                        <div className="nav-link-inner">
                                            <img
                                                src={workflowtimeline}
                                                alt="workflowtimeline"
                                                className="inactive-nav-icon"
                                            />
                                            <svg
                                                className="active-nav-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="23"
                                                height="22"
                                                viewBox="0 0 23 22"
                                                fill="none"
                                            >
                                                <g clip-path="url(#clip0_5514_10475)">
                                                    <path
                                                        d="M13.4993 0.18988C13.3671 0.165555 13.2312 0.17059 13.1012 0.204631C12.9712 0.238671 12.8502 0.300884 12.7469 0.386861C12.6436 0.472839 12.5605 0.580478 12.5034 0.702155C12.4464 0.823831 12.4167 0.956568 12.4167 1.09096V3.73005C11.3068 3.5828 10.1779 3.69313 9.11754 4.05249C8.05718 4.41184 7.09381 5.01057 6.30213 5.80225C5.51045 6.59393 4.91172 7.5573 4.55236 8.61766C4.19301 9.67803 4.08268 10.8069 4.22993 11.9168H1.59084C1.45645 11.9169 1.32371 11.9465 1.20203 12.0035C1.08036 12.0606 0.972718 12.1437 0.886741 12.247C0.800763 12.3503 0.738551 12.4713 0.70451 12.6013C0.67047 12.7313 0.665434 12.8672 0.68976 12.9994C1.05277 14.9716 1.94801 16.8071 3.27867 18.3073C4.60934 19.8076 6.32481 20.9155 8.23959 21.5114C10.1544 22.1072 12.1956 22.1683 14.1426 21.688C16.0896 21.2077 17.8682 20.2043 19.2862 18.7863C20.7042 17.3683 21.7076 15.5897 22.1879 13.6427C22.6682 11.6957 22.6071 9.65449 22.0112 7.73971C21.4154 5.82493 20.3074 4.10946 18.8072 2.77879C17.3069 1.44813 15.4715 0.55289 13.4993 0.18988ZM11.5 12.8335C11.1795 12.8326 10.8648 12.7474 10.5876 12.5865C10.3104 12.4256 10.0804 12.1947 9.92059 11.9168H7.83334C7.59023 11.9168 7.35707 11.8202 7.18516 11.6483C7.01325 11.4764 6.91668 11.2432 6.91668 11.0001C6.91668 10.757 7.01325 10.5239 7.18516 10.3519C7.35707 10.18 7.59023 10.0835 7.83334 10.0835H9.92059C10.0804 9.80885 10.3087 9.58047 10.5833 9.42071V6.4168C10.5833 6.17368 10.6799 5.94052 10.8518 5.76862C11.0237 5.59671 11.2569 5.50013 11.5 5.50013C11.7431 5.50013 11.9763 5.59671 12.1482 5.76862C12.3201 5.94052 12.4167 6.17368 12.4167 6.4168V9.42071C12.7663 9.62158 13.0397 9.93242 13.1943 10.3048C13.3489 10.6773 13.3761 11.0904 13.2715 11.4798C13.1669 11.8692 12.9364 12.2131 12.616 12.458C12.2956 12.7028 11.9032 12.8348 11.5 12.8335ZM9.64101 0.0917969C9.82231 0.0917969 9.99954 0.145558 10.1503 0.246283C10.301 0.347008 10.4185 0.490171 10.4879 0.65767C10.5573 0.825169 10.5754 1.00948 10.5401 1.1873C10.5047 1.36511 10.4174 1.52845 10.2892 1.65664C10.161 1.78484 9.99766 1.87215 9.81984 1.90752C9.64203 1.94289 9.45772 1.92473 9.29022 1.85535C9.12272 1.78597 8.97955 1.66848 8.87883 1.51774C8.7781 1.36699 8.72434 1.18976 8.72434 1.00846C8.72434 0.765348 8.82092 0.532191 8.99283 0.360282C9.16474 0.188374 9.39789 0.0917969 9.64101 0.0917969ZM5.88268 1.70146C6.06398 1.70146 6.2412 1.75523 6.39195 1.85595C6.54269 1.95667 6.66019 2.09984 6.72957 2.26734C6.79895 2.43484 6.8171 2.61915 6.78173 2.79696C6.74636 2.97478 6.65906 3.13811 6.53086 3.26631C6.40266 3.39451 6.23933 3.48181 6.06151 3.51718C5.88369 3.55255 5.69938 3.5344 5.53188 3.46502C5.36438 3.39564 5.22122 3.27815 5.1205 3.1274C5.01977 2.97666 4.96601 2.79943 4.96601 2.61813C4.96552 2.37517 5.06151 2.14196 5.23287 1.96973C5.40424 1.79751 5.63697 1.70036 5.87993 1.69963L5.88268 1.70146ZM3.04743 4.43771C3.22873 4.43771 3.40595 4.49148 3.5567 4.5922C3.70744 4.69292 3.82494 4.83609 3.89432 5.00359C3.9637 5.17109 3.98185 5.3554 3.94648 5.53321C3.91111 5.71103 3.82381 5.87436 3.69561 6.00256C3.56741 6.13076 3.40408 6.21806 3.22626 6.25343C3.04844 6.2888 2.86413 6.27065 2.69663 6.20127C2.52913 6.13189 2.38597 6.0144 2.28525 5.86365C2.18452 5.71291 2.13076 5.53568 2.13076 5.35438C2.13076 5.11127 2.22734 4.87811 2.39925 4.7062C2.57115 4.53429 2.80431 4.43771 3.04743 4.43771ZM1.58076 8.25746C1.76206 8.25746 1.93929 8.31122 2.09003 8.41195C2.24078 8.51267 2.35827 8.65584 2.42765 8.82334C2.49703 8.99084 2.51518 9.17515 2.47981 9.35296C2.44444 9.53078 2.35714 9.69411 2.22894 9.82231C2.10074 9.95051 1.93741 10.0378 1.75959 10.0732C1.58178 10.1086 1.39747 10.0904 1.22997 10.021C1.06247 9.95164 0.919304 9.83415 0.818579 9.6834C0.717855 9.53266 0.664093 9.35543 0.664093 9.17413C0.664093 8.93133 0.760418 8.69845 0.93193 8.5266C1.10344 8.35474 1.33613 8.25795 1.57893 8.25746H1.58076Z"
                                                        fill="black"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_5514_10475">
                                                        <rect
                                                            width="22"
                                                            height="22"
                                                            fill="white"
                                                            transform="translate(0.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span>Control Center</span>
                                        </div>
                                    </Nav.Link>
                                )}
                                {!checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => navigate("/marketplace")}
                                        className={
                                            (param.pagename === "Marketplace" ||
                                                isActive("/marketplace")) &&
                                            "active"
                                        }
                                    >
                                        <div className="nav-link-inner">
                                            <img
                                                src={marketplace}
                                                alt="marketplace"
                                                className="inactive-nav-icon"
                                            />
                                            <svg
                                                className="active-nav-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="23"
                                                height="22"
                                                viewBox="0 0 23 22"
                                                fill="none"
                                            >
                                                <g clip-path="url(#clip0_5514_10804)">
                                                    <path
                                                        d="M14.8333 21V15C14.8333 14.3777 14.8333 14.0666 14.7122 13.8289C14.6057 13.6198 14.4358 13.4499 14.2267 13.3433C13.989 13.2222 13.6779 13.2222 13.0556 13.2222H9.94445C9.32211 13.2222 9.01102 13.2222 8.77334 13.3433C8.56428 13.4499 8.3943 13.6198 8.28777 13.8289C8.16667 14.0666 8.16667 14.3777 8.16667 15V21M1.5 5.44444C1.5 7.28539 2.99239 8.77778 4.83333 8.77778C6.67428 8.77778 8.16667 7.28539 8.16667 5.44444C8.16667 7.28539 9.659 8.77778 11.5 8.77778C13.341 8.77778 14.8333 7.28539 14.8333 5.44444C14.8333 7.28539 16.3257 8.77778 18.1667 8.77778C20.0077 8.77778 21.5 7.28539 21.5 5.44444M5.05556 21H17.9444C19.189 21 19.8113 21 20.2867 20.7578C20.7048 20.5448 21.0448 20.2048 21.2578 19.7867C21.5 19.3113 21.5 18.689 21.5 17.4444V4.55556C21.5 3.311 21.5 2.68871 21.2578 2.21336C21.0448 1.79521 20.7048 1.45526 20.2867 1.24221C19.8113 1 19.189 1 17.9444 1H5.05556C3.811 1 3.18871 1 2.71336 1.24221C2.29521 1.45526 1.95526 1.79521 1.74221 2.21336C1.5 2.68871 1.5 3.31099 1.5 4.55556V17.4444C1.5 18.689 1.5 19.3113 1.74221 19.7867C1.95526 20.2048 2.29521 20.5448 2.71336 20.7578C3.18871 21 3.81099 21 5.05556 21Z"
                                                        fill="#111111"
                                                    />
                                                    <path
                                                        d="M14.8333 21V15C14.8333 14.3777 14.8333 14.0666 14.7122 13.8289C14.6057 13.6198 14.4358 13.4499 14.2267 13.3433C13.989 13.2222 13.6779 13.2222 13.0556 13.2222H9.94445C9.32211 13.2222 9.01102 13.2222 8.77334 13.3433C8.56428 13.4499 8.3943 13.6198 8.28777 13.8289C8.16667 14.0666 8.16667 14.3777 8.16667 15V21M1.5 5.44444C1.5 7.28539 2.99239 8.77778 4.83333 8.77778C6.67428 8.77778 8.16667 7.28539 8.16667 5.44444C8.16667 7.28539 9.659 8.77778 11.5 8.77778C13.341 8.77778 14.8333 7.28539 14.8333 5.44444C14.8333 7.28539 16.3257 8.77778 18.1667 8.77778C20.0077 8.77778 21.5 7.28539 21.5 5.44444M5.05556 21H17.9444C19.189 21 19.8113 21 20.2867 20.7578C20.7048 20.5448 21.0448 20.2048 21.2578 19.7867C21.5 19.3113 21.5 18.689 21.5 17.4444V4.55556C21.5 3.311 21.5 2.68871 21.2578 2.21336C21.0448 1.79521 20.7048 1.45526 20.2867 1.24221C19.8113 1 19.189 1 17.9444 1H5.05556C3.811 1 3.18871 1 2.71336 1.24221C2.29521 1.45526 1.95526 1.79521 1.74221 2.21336C1.5 2.68871 1.5 3.31099 1.5 4.55556V17.4444C1.5 18.689 1.5 19.3113 1.74221 19.7867C1.95526 20.2048 2.29521 20.5448 2.71336 20.7578C3.18871 21 3.81099 21 5.05556 21Z"
                                                        stroke="#AADBFF"
                                                        stroke-width="1.5"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_5514_10804">
                                                        <rect
                                                            width="22"
                                                            height="22"
                                                            fill="white"
                                                            transform="translate(0.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span>Marketplace</span>
                                        </div>
                                    </Nav.Link>
                                )}
                                {DevRoute && !checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => navigate("/machine")}
                                        // className={isActive("/machine")}
                                        className={
                                            (param.pagename === "my machine" ||
                                                isActive("/machine")) &&
                                            "active"
                                        }
                                    >
                                        <div className="nav-link-inner">
                                            <img
                                                src={mymachine}
                                                alt="marketplace"
                                                className="inactive-nav-icon"
                                            />
                                            <svg
                                                className="active-nav-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="23"
                                                height="22"
                                                viewBox="0 0 23 22"
                                                fill="none"
                                            >
                                                <g clip-path="url(#clip0_3308_17297)">
                                                    <path
                                                        d="M5.26523 0C5.08992 0 4.92621 0.0717578 4.80934 0.188633L0.700234 4.29816C0.562305 4.43609 0.5 4.60109 0.5 4.7648H5.26523V0Z"
                                                        fill="black"
                                                    />
                                                    <path
                                                        d="M13.2458 17.7482C13.0688 17.8007 12.8836 17.8282 12.6971 17.8282C12.1819 17.8282 11.6977 17.6279 11.3329 17.2648L9.79027 15.7287C9.26863 15.2105 9.10019 14.4637 9.30258 13.7968C8.6877 13.4703 8.27734 12.824 8.27734 12.0888V9.91117C8.27734 9.18328 8.67953 8.54262 9.2841 8.21305C9.08859 7.55348 9.25531 6.8157 9.76836 6.29965L11.3045 4.75707C11.6697 4.38926 12.1566 4.18688 12.6752 4.18688C12.866 4.18688 13.055 4.21566 13.2359 4.27066C13.5625 3.65492 14.2087 3.24414 14.9444 3.24414H16.6777V0.644531C16.6777 0.28875 16.389 0 16.0332 0H6.5543V5.40934C6.5543 5.76512 6.26555 6.05387 5.90977 6.05387H0.5V21.3555C0.5 21.7113 0.78875 22 1.14453 22H16.0332C16.389 22 16.6777 21.7113 16.6777 21.3555V18.7559H14.9444C14.2161 18.7559 13.5754 18.3532 13.2458 17.7482ZM6.36867 18.9445H2.45852C2.10273 18.9445 1.81398 18.6562 1.81398 18.3C1.81398 17.9442 2.10273 17.6554 2.45852 17.6554H6.36867C6.72445 17.6554 7.0132 17.9442 7.0132 18.3C7.0132 18.6562 6.72445 18.9445 6.36867 18.9445ZM6.36867 16.3664H2.45852C2.10273 16.3664 1.81398 16.078 1.81398 15.7218C1.81398 15.3661 2.10273 15.0773 2.45852 15.0773H6.36867C6.72445 15.0773 7.0132 15.3661 7.0132 15.7218C7.0132 16.078 6.72445 16.3664 6.36867 16.3664ZM6.36867 13.7882H2.45852C2.10273 13.7882 1.81398 13.4999 1.81398 13.1437C1.81398 12.7879 2.10273 12.4992 2.45852 12.4992H6.36867C6.72445 12.4992 7.0132 12.7879 7.0132 13.1437C7.0132 13.4999 6.72445 13.7882 6.36867 13.7882ZM6.36867 11.2101H2.45852C2.10273 11.2101 1.81398 10.9218 1.81398 10.5656C1.81398 10.2098 2.10273 9.92105 2.45852 9.92105H6.36867C6.72445 9.92105 7.0132 10.2098 7.0132 10.5656C7.0132 10.9218 6.72445 11.2101 6.36867 11.2101ZM6.36867 8.63199H2.45852C2.10273 8.63199 1.81398 8.34367 1.81398 7.98746C1.81398 7.63168 2.10273 7.34293 2.45852 7.34293H6.36867C6.72445 7.34293 7.0132 7.63168 7.0132 7.98746C7.0132 8.34367 6.72445 8.63199 6.36867 8.63199Z"
                                                        fill="black"
                                                    />
                                                    <path
                                                        d="M21.9264 9.27051L20.56 9.11883L21.4168 8.04375C21.6213 7.7868 21.6002 7.41684 21.3673 7.18523L19.8239 5.64867C19.5914 5.41707 19.2215 5.3973 18.9654 5.60312L17.9118 6.45047L17.7627 5.10684C17.7266 4.78027 17.4507 4.5332 17.122 4.5332H14.9444C14.6157 4.5332 14.3398 4.78027 14.3037 5.10684L14.152 6.47324L13.077 5.61645C12.82 5.41191 12.45 5.43297 12.2184 5.66586L10.6819 7.2093C10.4503 7.44219 10.4305 7.81172 10.6363 8.06781L11.4837 9.12141L10.14 9.27051C9.81348 9.3066 9.56641 9.58289 9.56641 9.91117V12.0888C9.56641 12.4171 9.81348 12.6934 10.14 12.7295L11.5064 12.8812L10.6496 13.9562C10.4451 14.2132 10.4662 14.5832 10.6991 14.8148L12.2425 16.3513C12.475 16.5829 12.8449 16.6027 13.101 16.3969L14.1546 15.5495L14.3037 16.8932C14.3398 17.2197 14.6157 17.4668 14.9444 17.4668H17.122C17.4507 17.4668 17.7266 17.2197 17.7627 16.8932L17.9144 15.5268L18.9895 16.3836C19.2464 16.5881 19.6164 16.567 19.848 16.3341L21.3845 14.7907C21.6161 14.5578 21.6359 14.1883 21.4301 13.9322L20.5827 12.8786L21.9264 12.7295C22.2529 12.6934 22.5 12.4171 22.5 12.0888V9.91117C22.5 9.58289 22.2529 9.3066 21.9264 9.27051ZM16.0332 13.423C14.6973 13.423 13.6102 12.3359 13.6102 11C13.6102 9.6641 14.6973 8.57699 16.0332 8.57699C17.3691 8.57699 18.4562 9.6641 18.4562 11C18.4562 12.3359 17.3691 13.423 16.0332 13.423Z"
                                                        fill="black"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_3308_17297">
                                                        <rect
                                                            width="22"
                                                            height="22"
                                                            fill="white"
                                                            transform="translate(0.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span>My Machines</span>
                                        </div>
                                    </Nav.Link>
                                )}
                                {DevRoute && !checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => {
                                            const token = localStorage.getItem("Token") || "";
                                            window.open(`${process.env.REACT_APP_BOTCRAFT_URL}/?t=${token}`, "_blank");
                                        }}
                                    >
                                        <div className="nav-link-inner">
                                            <svg
                                                className="inactive-nav-icon"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-4h2v2h-2v-2zm1-10c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
                                                    fill="black"
                                                />
                                            </svg>
                                            <span>Botcraft AI</span>
                                        </div>
                                    </Nav.Link>
                                )}
                                {checkUserIsReviewer() && (
                                    <Nav.Link
                                        onClick={() => navigate("/machine-review")}
                                        className={isActive("/machine-review")}
                                    >
                                        <div className="nav-link-inner">
                                            {/* <img src={reviewIcon} alt="Review" />
                    <span>Review</span> */}
                                            <svg
                                                className="inactive-nav-icon"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g id="fi_1946488" clip-path="url(#clip0_0_6845)">
                                                    <path
                                                        id="Vector"
                                                        d="M20.5792 9.65068C20.5786 9.65022 20.5781 9.6496 20.5776 9.64914L12.3504 1.42304C11.9997 1.07224 11.5335 0.87915 11.0375 0.87915C10.5416 0.87915 10.0754 1.07224 9.72453 1.42304L1.50161 9.64499C1.49884 9.64775 1.49592 9.65068 1.4933 9.65345C0.773165 10.3777 0.774396 11.5527 1.49684 12.2751C1.8269 12.6052 2.26268 12.7963 2.72876 12.8165C2.74784 12.8183 2.76692 12.8193 2.78616 12.8193H3.11391V18.873C3.11391 20.0711 4.08886 21.0458 5.28709 21.0458H8.50585C8.83221 21.0458 9.09673 20.7812 9.09673 20.455V15.7087C9.09673 15.1621 9.54158 14.7174 10.0883 14.7174H11.9868C12.5335 14.7174 12.9782 15.1621 12.9782 15.7087V20.455C12.9782 20.7812 13.2427 21.0458 13.5691 21.0458H16.7879C17.9862 21.0458 18.961 20.0711 18.961 18.873V12.8193H19.2651C19.7609 12.8193 20.2271 12.6262 20.5781 12.2752C21.3013 11.5518 21.3016 10.3746 20.5792 9.65068ZM19.7424 11.4398C19.6149 11.5673 19.4453 11.6376 19.2651 11.6376H18.3702C18.0438 11.6376 17.7793 11.9021 17.7793 12.2284V18.873C17.7793 19.4195 17.3346 19.8642 16.7879 19.8642H14.16V15.7087C14.16 14.5106 13.1852 13.5358 11.9868 13.5358H10.0883C8.88992 13.5358 7.91497 14.5106 7.91497 15.7087V19.8642H5.28709C4.74052 19.8642 4.29567 19.4195 4.29567 18.873V12.2284C4.29567 11.9021 4.03116 11.6376 3.70479 11.6376H2.82524C2.81601 11.637 2.80693 11.6365 2.79754 11.6364C2.62151 11.6333 2.4564 11.5635 2.33269 11.4396C2.06956 11.1765 2.06956 10.7483 2.33269 10.4851C2.33284 10.4851 2.33284 10.4849 2.333 10.4847L2.33346 10.4843L10.5604 2.2585C10.6878 2.13095 10.8572 2.06079 11.0375 2.06079C11.2177 2.06079 11.3872 2.13095 11.5147 2.2585L19.7398 10.4826C19.741 10.4838 19.7424 10.4851 19.7436 10.4863C20.0054 10.7498 20.0049 11.1771 19.7424 11.4398Z"
                                                        fill="#5E5E5E"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_0_6845">
                                                        <rect width="22" height="22" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                            <svg
                                                className="active-nav-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                            >
                                                <g clip-path="url(#clip0_2769_20345)">
                                                    <path
                                                        d="M1.5 10.5L11 1.5L18 8L20.5 11.5L18 13V20H13.5V14.5H8.5V20H4L3.5 12.5L2.5 12L1.5 10.5Z"
                                                        fill="#111111"
                                                    />
                                                    <path
                                                        d="M20.5802 9.65043C20.5795 9.64997 20.5791 9.64936 20.5786 9.6489L12.3514 1.4228C12.0007 1.072 11.5345 0.878906 11.0385 0.878906C10.5426 0.878906 10.0763 1.072 9.72551 1.4228L1.50259 9.64474C1.49982 9.64751 1.49689 9.65043 1.49428 9.6532C0.774142 10.3774 0.775373 11.5524 1.49782 12.2748C1.82788 12.605 2.26365 12.7961 2.72974 12.8162C2.74882 12.8181 2.7679 12.819 2.78713 12.819H3.11489V18.8728C3.11489 20.0709 4.08984 21.0456 5.28806 21.0456H8.50682C8.83319 21.0456 9.0977 20.7809 9.0977 20.4548V15.7085C9.0977 15.1618 9.54255 14.7172 10.0893 14.7172H11.9878C12.5345 14.7172 12.9792 15.1618 12.9792 15.7085V20.4548C12.9792 20.7809 13.2437 21.0456 13.5701 21.0456H16.7888C17.9872 21.0456 18.962 20.0709 18.962 18.8728V12.819H19.2661C19.7619 12.819 20.2281 12.6259 20.5791 12.275C21.3023 11.5515 21.3026 10.3743 20.5802 9.65043ZM19.7434 11.4395C19.6158 11.5671 19.4463 11.6374 19.2661 11.6374H18.3711C18.0448 11.6374 17.7803 11.9019 17.7803 12.2282V18.8728C17.7803 19.4193 17.3356 19.8639 16.7888 19.8639H14.161V15.7085C14.161 14.5104 13.1862 13.5355 11.9878 13.5355H10.0893C8.89089 13.5355 7.91594 14.5104 7.91594 15.7085V19.8639H5.28806C4.7415 19.8639 4.29665 19.4193 4.29665 18.8728V12.2282C4.29665 11.9019 4.03214 11.6374 3.70577 11.6374H2.82622C2.81699 11.6368 2.80791 11.6363 2.79852 11.6361C2.62249 11.6331 2.45738 11.5632 2.33366 11.4394C2.07054 11.1763 2.07054 10.7481 2.33366 10.4848C2.33382 10.4848 2.33382 10.4847 2.33397 10.4845L2.33443 10.484L10.5614 2.25826C10.6888 2.13071 10.8582 2.06055 11.0385 2.06055C11.2187 2.06055 11.3881 2.13071 11.5157 2.25826L19.7408 10.4824C19.742 10.4836 19.7434 10.4848 19.7446 10.486C20.0064 10.7496 20.0059 11.1769 19.7434 11.4395Z"
                                                        fill="#111111"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2769_20345">
                                                        <rect width="22" height="22" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span>Home</span>
                                        </div>
                                    </Nav.Link>
                                )}

                                {/* <Nav.Link
                onClick={() => navigate("/poc")}
                className={isActive("/poc")}
              >
                <div className="nav-link-inner">
                  <img src={marketplace} alt="marketplace" />
                  <span>POC</span>
                </div>
              </Nav.Link> */}

                                {/* <NavDropdown title="Link" id="navbarScrollingDropdown">
                <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action4">
                  Another action
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action5">
                  Something else here
                </NavDropdown.Item>
              </NavDropdown> */}
                                {/* <Nav.Link href="#" disabled>
                Link
              </Nav.Link> */}
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                    <div className="navbar-right">
                        {/* hide search bar conform with ashish */}
                        {/* {showSearch ? (
              <div className="header-search-input">
                <InputGroup>
                  <InputGroup.Text id="basic-addon1">
                    <img src={searchicon} alt="searchicon" />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                  />
                </InputGroup>
              </div>
            ) : (
              !checkUserIsReviewer() && (
                <img
                  src={searchicon}
                  alt="searchicon"
                  onClick={handleshowSearch}
                  className="sm-icons"
                />
              )
            )} */}
                        <Navbar.Toggle aria-controls="navbarScroll" />

                        <div className="navbar-right-iconbox">
                            {OrgList?.length > 0 && (
                                <>
                                    {!checkUserIsReviewer() && (
                                        <button
                                            ref={target1}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowMenu(!showMenu);
                                                // handleOverlay(e);
                                                handleshowMenu();
                                            }}
                                            className={
                                                showMenu ? "overlay-isopen btn-link service-head-btn" : "btn-link service-head-btn"
                                            }
                                        >
                                            {OrgList?.find(
                                                (item) => Userdata?.subscriberid === item?.subscriberid
                                            )?.companyname ||
                                                OrgList?.find(
                                                    (item) =>
                                                        Userdata?.subscriberid === item?.subscriberid
                                                )?.subscribername}
                                            <img
                                                src={service}
                                                alt="home"
                                                className="sm-icons"
                                                id="service-menu"
                                            />
                                        </button>
                                    )}
                                </>
                            )}
                            {!checkUserIsReviewer() && (
                                <div
                                    className={
                                        addToCartShow
                                            ? "position-relative overlay-isopen"
                                            : "position-relative"
                                    }
                                >
                                    <button
                                        className={
                                            addToCartShow ? "overlay-isopen btn-link" : "btn-link"
                                        }
                                        onClick={() => {
                                            setAddToCartShow(true);
                                        }}
                                    >
                                        <img
                                            style={{ width: "20px", height: "20px" }}
                                            src={cart}
                                            alt="Cart"
                                        // onClick={(e) => {
                                        //   e.preventDefault();
                                        //   setShow(!show);
                                        //   handleshowNotification();
                                        // }}
                                        // ref={target}
                                        />
                                    </button>
                                    {CartList?.length > 0 && (
                                        <div className="cart-num">{CartList?.length}</div>
                                    )}
                                </div>
                            )}
                            {!checkUserIsReviewer() && (
                                <button
                                    className={
                                        showNotification
                                            ? "overlay-isopen btn-link notification-blink-btn"
                                            : "btn-link notification-blink-btn"
                                    }
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowNotification(!showNotification);
                                        handleshowNotification();
                                    }}
                                >
                                    <img
                                        src={notification}
                                        alt="Notification"
                                        className="sm-icons"
                                        ref={target}
                                    // className="sm-icons"
                                    />
                                    {notificationList?.[0]?.isunreadnotification === true && (
                                        <span className="notification-count"></span>
                                    )}
                                </button>
                            )}
                        </div>

                        <Dropdown
                            show={dropdownOpen}
                            onToggle={() => setDropdownOpen(!dropdownOpen)}
                            className="header-profile-dropdown"
                        >
                            <Dropdown.Toggle
                                className="profilemain-popup-btn"
                                id="dropdown-basic"
                            >
                                <img
                                    src={
                                        Userdata?.profilepicurl
                                            ? Userdata?.profilepicurl
                                            : profilepic1
                                    }
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = profilepic1;
                                    }}
                                    alt="profilepic"
                                />
                                <div className="header-name">
                                    <span title={Userdata?.displayname}>
                                        {commonservices?.truncateText(
                                            Userdata?.displayname,
                                            CountCharacter.HeaderDisplayName
                                        )}
                                    </span>
                                    <span className="header-role-name">
                                        {Userdata?.associationtype}
                                    </span>
                                </div>
                                {/* <span>{Userdata?.displayname}</span> */}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="profilemain-popup">
                                {/* <Dropdown.Item onClick={(e) => setProfileModalShow(true)}> */}
                                {
                                    <div className="usercode-profile-show">
                                        <div className="dummyprofile-inner">
                                            <img
                                                src={
                                                    Userdata?.profilepicurl
                                                        ? Userdata?.profilepicurl
                                                        : profilepic1
                                                }
                                                onError={({ currentTarget }) => {
                                                    currentTarget.onerror = null;
                                                    currentTarget.src = profilepic1;
                                                }}
                                                alt="profilepic"
                                            />
                                            {/* <img src={dummyprofilepic} alt="dummy-profile-pic" /> */}
                                            <div className="userprofile-name-code">
                                                <span
                                                    className="userprofile-name-code-title"
                                                    title={Userdata?.displayname}
                                                >
                                                    {/* {commonservices?.truncateText(
                              Userdata?.displayname,
                              CountCharacter.HeaderDisplayName
                            )} */}
                                                    {Userdata?.displayname}
                                                </span>
                                                <div className="user-code-box">
                                                    <span className="theme-cardnumber-data">
                                                        {Userdata?.usercode}
                                                    </span>
                                                    <Link title="Copy Usercode">
                                                        <img
                                                            style={{ filter: "brightness(0)" }}
                                                            src={copyicon}
                                                            alt="copy"
                                                            onClick={() => {
                                                                handleCopy(Userdata?.usercode);
                                                            }}
                                                            height={"18px"}
                                                            width={"21px"}
                                                        />{" "}
                                                    </Link>
                                                </div>{" "}
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className="profile-nav-list">
                                    {!checkUserIsReviewer() && (
                                        <Dropdown.Item
                                            title="Notifications"
                                            onClick={(e) =>
                                                navigate("/management-listing", {
                                                    state: "notification",
                                                })
                                            }
                                        >
                                            <div className="d-flex gap-2">
                                                <img
                                                    src={notificationprofile}
                                                    alt="notificationprofile"
                                                />
                                                <span>Notifications</span>
                                            </div>
                                        </Dropdown.Item>
                                    )}
                                    {IsWorkflowUser &&
                                        Userdata?.associationtype === "Subscribers" && (
                                            <Dropdown.Item
                                                title="Billing & Cost Management"
                                                onClick={(e) =>
                                                    navigate("/billing-and-cost-maangement")
                                                }
                                                className="border-0"
                                            >
                                                <div className="d-flex gap-2">
                                                    <img
                                                        src={BillingCost}
                                                        alt="Biling & Cost Management"
                                                    />
                                                    <span>Billing & Cost Management</span>
                                                </div>
                                            </Dropdown.Item>
                                        )}
                                    <Dropdown.Divider />
                                    <Dropdown.Item
                                        title="Profile"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate("/management-listing", { state: "profile" });
                                            setDropdownOpen(true);
                                            setProfileModalShow(true);
                                        }}
                                    >
                                        <div className="d-flex gap-2">
                                            <img src={profileicon} alt="profileicon" />
                                            <span>Profile</span>{" "}
                                        </div>
                                    </Dropdown.Item>
                                    {/* {Userdata?.isprofilecompleted &&
                  Userdata?.associationtype?.toUpperCase() !== "CONTACTS" && (
                    <>
                      {window?.location?.href?.includes(
                        `${process.env.REACT_APP_WORKFLOW}`
                      )
                        ? !checkUserIsReviewer() && (
                            <Dropdown.Item
                              onClick={() => handleItemClick("Developer")}
                              // onClick={(e) => {
                              //   e.preventDefault();
                              //   checkBecomeClient();
                              // }}
                              // href={`${process.env.REACT_APP_DEV}/continue?t=123456`}
                            >
                              <div className="d-flex gap-2">
                                <img src={Developer} alt="accountprofile" />
                                <span>Developer</span>
                              </div>
                            </Dropdown.Item>
                          )
                        : !checkUserIsReviewer() && (
                            <Dropdown.Item
                              onClick={() => handleItemClick("Workflow")}
                              // onClick={(e) => {
                              //   e.preventDefault();
                              //   checkBecomeDeveloper();
                              // }}
                              // href={`${process.env.REACT_APP_WORKFLOW}/continue?t=123456`}
                            >
                              <div className="d-flex gap-2">
                                <img src={policyprofile} alt="accountprofile" />
                                <span>Workflow</span>
                              </div>
                            </Dropdown.Item>
                          )}
                    </>
                  )} */}
                                    {Userdata?.associationtype === "Subscribers" &&
                                        !checkUserIsReviewer() &&
                                        Userdata?.associationtype !== "Contacts" && (
                                            <>
                                                <Dropdown.Item
                                                    title="Account"
                                                    onClick={(e) =>
                                                        navigate("/management-listing", {
                                                            state: "account",
                                                        })
                                                    }
                                                >
                                                    <div className="d-flex gap-2">
                                                        <img src={accountprofile} alt="accountprofile" />
                                                        <span>Account</span>
                                                    </div>
                                                </Dropdown.Item>
                                            </>
                                        )}
                                    {
                                        <Dropdown.Item
                                            title="Password & Authentication"
                                            onClick={(e) =>
                                                navigate("/management-listing", {
                                                    state: "authentication",
                                                })
                                            }
                                        >
                                            <div className="d-flex gap-2">
                                                <img src={authentication} alt="authentication" />
                                                <span>Password & Authentication</span>{" "}
                                            </div>
                                        </Dropdown.Item>
                                    }
                                    {Userdata?.isorganization &&
                                        (Userdata?.associationtype === "Subscribers" || Userdata?.workflowrolename === "Workflow Admin") &&
                                        !checkUserIsReviewer() && (
                                            <Dropdown.Item
                                                title="Contacts"
                                                onClick={(e) =>
                                                    navigate("/management-listing", { state: "contacts" })
                                                }
                                            >
                                                <div className="d-flex gap-2">
                                                    <img src={contacts} alt="contacts" />
                                                    <span>Contacts</span>
                                                </div>
                                            </Dropdown.Item>
                                        )}
                                    <Dropdown.Item
                                        title="Payment Management"
                                        onClick={(e) =>
                                            navigate("/management-listing", { state: "wallet" })
                                        }
                                    >
                                        <div className="d-flex gap-2">
                                            <img src={WalletSVG} alt="Wallet" />
                                            <span>Payment Management</span>
                                        </div>
                                    </Dropdown.Item>
                                    {IsWorkflowUser && (
                                        <Dropdown.Item
                                            title="Password Vault"
                                            onClick={(e) =>
                                                navigate("/management-listing", {
                                                    state: "passwordvault",
                                                })
                                            }
                                        >
                                            <div className="d-flex gap-2">
                                                <img src={hideeye} alt="contacts" />
                                                <span>Password Vault</span>
                                            </div>
                                        </Dropdown.Item>
                                    )}
                                    {/* {!checkUserIsReviewer() &&
                  Userdata?.associationtype !== "Contacts" && (
                    <Dropdown.Item
                      onClick={(e) =>
                        navigate("/management-listing", { state: "purchases" })
                      }
                    >
                      <div className="d-flex gap-2">
                        <img src={purchases} alt="contacts" />
                        <span>Purchase</span>
                      </div>
                    </Dropdown.Item>
                  )} */}
                                    {!checkUserIsReviewer() && (
                                        <Dropdown.Item
                                            title="Support"
                                            onClick={(e) => {
                                                // e.stopPropagation();
                                                // setDataId(null);
                                                navigate("/management-listing?r=0", {
                                                    state: "cases",
                                                });
                                            }}
                                        >
                                            <div className="d-flex gap-2">
                                                <img src={Support} alt="authentication" />
                                                <span>Support</span>
                                            </div>
                                        </Dropdown.Item>
                                    )}
                                    {!checkUserIsReviewer() &&
                                        Userdata?.associationtype !== "Contacts" && (
                                            <Dropdown.Item
                                                title="Billings & Plans"
                                                onClick={(e) =>
                                                    navigate("/management-listing", {
                                                        state: "membership",
                                                    })
                                                }
                                            >
                                                <div className="d-flex gap-2">
                                                    <img src={billingsplans} alt="authentication" />
                                                    <span>Billings & Plans</span>
                                                </div>
                                            </Dropdown.Item>
                                        )}
                                    {!checkUserIsReviewer() &&
                                        Userdata?.associationtype !== "Contacts" && (
                                            <Dropdown.Item
                                                title="Legal"
                                                onClick={(e) =>
                                                    navigate("/management-listing", { state: "Legal" })
                                                }
                                            >
                                                <div className="d-flex gap-2">
                                                    <img src={legal} alt="legal" />
                                                    <span>Legal</span>
                                                </div>
                                            </Dropdown.Item>
                                        )}
                                    {!checkUserIsReviewer() && (
                                        <Dropdown.Item
                                            title="Code, Engineering & Automation"
                                            onClick={(e) =>
                                                navigate("/management-listing", {
                                                    state: DevRoute ? "machines" : "workflow",
                                                })
                                            }
                                        >
                                            <div className="d-flex gap-2">
                                                <img src={automation} alt="automation" />
                                                <span>Code, Engineering & Automation</span>
                                            </div>
                                        </Dropdown.Item>
                                    )}

                                    {IsWorkflowUser && (
                                        <Dropdown.Item
                                            title="Infrastructure Automation"
                                            onClick={(e) =>
                                                navigate("/management-listing", {
                                                    state: "infrastructureautomation",
                                                })
                                            }
                                        >
                                            <div className="d-flex gap-2">
                                                <img src={aws} alt="contacts" />
                                                <span>Infrastructure Automation</span>
                                            </div>
                                        </Dropdown.Item>
                                    )}

                                    <Dropdown.Item
                                        title="Logout"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setLogoutModalShow(true);
                                            // setDeletePayload({
                                            //   ...DeletePayload,
                                            //   id: item?.subscriberscontactid,
                                            // });
                                        }}
                                    // onClick={fnLogout}
                                    >
                                        <div className="d-flex gap-2">
                                            <img
                                                src={logout}
                                                alt="policyprofile"
                                                height={"21px"}
                                                width={"18px"}
                                            />
                                            <span>Logout</span>
                                        </div>
                                    </Dropdown.Item>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </Container>
            </Navbar>
            {/* {OrganizationList?.length > 0 &&} */}
            {showMenu ? (
                <Overlay
                    ref={overlayMenues_Ref}
                    target={target1.current}
                    show={showMenu}
                    placement="bottom-end"
                >
                    {(props) => (
                        <Tooltip
                            className="service-main-popup"
                            id="overlay-example"
                            {...props}
                        >
                            <ServicesMenu handleshowPopup={handleshowMenu} />
                        </Tooltip>
                    )}
                </Overlay>
            ) : (
                ""
            )}
            {showNotification ? (
                <>
                    <Overlay
                        ref={overlayNoti_Ref}
                        target={target.current}
                        show={showNotification}
                        placement="bottom"
                    >
                        {(props) => (
                            <Tooltip id="overlay-example" {...props}>
                                <NotificationPopup
                                    closePopup={handleshowNotification}
                                    setgetNotificationList={getNotificationList}
                                />
                            </Tooltip>
                        )}
                    </Overlay>
                </>
            ) : (
                ""
            )}
            {LogoutModalShow && (
                <LogoutModal
                    show={LogoutModalShow}
                    bindlist={fnLogout}
                    onHide={(e) => setLogoutModalShow(false)}
                />
            )}
            {workflowPassModalShow && (
                <WorkFlowPassModal
                    // selectedcontact={SelectedContact}
                    // type={ContactModalType}
                    show={workflowPassModalShow}
                    // bindlist={getContactList}
                    onHide={(e) => setWorkflowPassModalShow(false)}
                />
            )}
            {addToCartShow && (
                <AddToCartModal
                    show={addToCartShow}
                    // onsubmit={fnPurchase}
                    // loader={PurchaseLoader}
                    subscriberId={Userdata?.subscriberid ? Userdata?.subscriberid : 0}
                    // verifytext={setVerifymailText}
                    onHide={() => setAddToCartShow(false)}
                />
            )}
        </div>
    );
}

export default Header;
